import { Flex } from 'components/common/styles'
import { StyledLogo } from 'components/Layout/App/Sidenav/Sidenav.styles'
import { GRAY6, GRAY5, PRIMARY_TEXT, BLACK_RGB, WHITE } from 'constants/colors'
import { APP_SIDEBAR_WIDTH, APP_HEADER_HEIGHT } from 'constants/sizes'
import { LAPTOP_BREAKPOINT } from 'helpers/responsive'
import styled, { createGlobalStyle, css } from 'styled-components'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import Avatar from '@material-ui/core/Avatar'

export const StyledHeaderLicenseeLogo = styled(Flex)`
  max-width: 150px;
  height: 100%;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`

export const StyledHeader = styled.section`
  position: fixed;
  left: ${APP_SIDEBAR_WIDTH};
  top: 0;
  right: 0;
  z-index: 1100;

  @media (max-width: ${LAPTOP_BREAKPOINT}px) {
    left: 0;
  }

  ${StyledLogo} {
    position: absolute;
    left: 0;
    top: 0;
    margin: 0;

    svg path {
      fill: ${PRIMARY_TEXT};
    }
  }
`

export const StyledHeaderButton = styled(IconButton)`
  .MuiBadge-badge {
    top: 5px;
  }
`

export const StyledHeaderRightSection = styled(Flex)`
  position: absolute;
  right: 12px;
  top: 12px;
  height: calc(${APP_HEADER_HEIGHT} - 24px);

  ${StyledHeaderButton} {
    &:hover {
      background: transparent;
    }

    .MuiIconButton-label {
      position: relative;

      &:after {
        position: absolute;
        opacity: 0;
        content: '';
        inset: -10px;
        background: rgba(${BLACK_RGB}, 0.04);
        z-index: -1;
        border-radius: 50%;
      }

      &:hover:after {
        opacity: 1;
      }
    }
  }
`

export const StyledDivider = styled.div`
  border: 1px solid rgba(${BLACK_RGB}, 0.1);
  margin: 8px 0;
`

export const StyledNavLeftMenu = styled(MenuList)`
  margin-right: 20px;
  border-right: 1px solid ${GRAY6};

  &.MuiList-padding {
    padding: 0 20px 0 0;
  }
`

export const StyledNavRightMenu = styled(MenuList)`
  position: relative;

  &.MuiList-padding {
    padding: 0 0 40px 20px;
  }
`

export const StyledNavMenuItem = styled(MenuItem)<{
  component?: string
}>`
  display: flex;
  align-items: center;
  min-height: auto;
  font-size: 0.875rem;
  padding: 0;
`

export const StyledAppHeaderDropdown = styled(Popover)`
  li {
    height: auto;
    padding: 0;
    min-height: 30px;

    &:first-child {
      margin-bottom: 15px;
    }

    strong {
      margin-left: 5px;
    }

    > div,
    > a {
      width: 100%;
      padding: 0;
    }

    a {
      display: block;
      width: 100%;
      color: ${GRAY5};
      padding: 4px 10px;
    }

    i {
      position: relative;
      top: -1px;
      vertical-align: middle;
      margin-right: 0.5rem;
      font-size: 1rem;
    }

    .MuiSelect-selectMenu {
      color: ${GRAY5};
    }
  }

  a {
    display: block;
    width: 100%;
    color: #565970;
    padding: 4px 10px;

    &:hover {
      text-decoration: none;
    }
  }

  .right-menu-paper {
    right: 16px;
    display: flex;
    padding: 20px;
  }
`

export const StyledMenuLogout = styled(MenuItem)`
  &.MuiMenuItem-root {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
`

export const StyledAvatar = styled(Avatar)<{ component: string }>`
  &.MuiAvatar-root {
    width: 27px;
    height: 27px;
  }
`

export const StyledMenuIcons = styled.i`
  display: inline-block;
  text-align: center;
  min-width: 18px;
  margin-right: 10px;
`

export const StyledMenuButton = styled(Flex)`
  position: absolute;
  right: 20px;
  top: 16px;
  width: 32px;
  height: 32px;
  min-width: 0;
  padding: 0;
`

export const HeaderGlobalStyles = createGlobalStyle<{ paddingRight?: number }>`
  .header-new {
    .table-toolbar {
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .app-content-wrapper .app-content .content-container .content .table-container.container-fluid.no-breadcrumb {
      height: 100%;
      overflow: hidden;

      .table-content {
        height: 100%;

        .table-wrapper {
          height: calc(100% - 130px);

          .MuiTableHead-root {
            position: sticky;
            top: 0;
            background: ${WHITE};
            z-index: 1;
          }
        }
      }
    }

    .fixed-header .app-page-container .table-toolbar .MuiToolbar-gutters, .jobs-triggers-header, .projected-sites-manager .header, .module-sales-dashboard .type-filter {
      padding-right: ${({ paddingRight }) =>
        css`calc(24px + ${paddingRight}px)`};
    }
  }

`
